"use client";

import { useState } from "react";
//import { Button } from "/Button";

export default function ContactoForm() {
  const [formData, setFormData] = useState({
    nombre: "",
    email: "",
    mensaje: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch("https://formspree.io/f/xyzwvlrw", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          nombre: formData.nombre,
          email: formData.email,
          mensaje: formData.mensaje,
        }),
      });

      if (response.ok) {
        setSuccess(true);
        setFormData({ nombre: "", email: "", mensaje: "" });
      } else {
        alert("Error al enviar. Intenta de nuevo.");
      }
    } catch (error) {
      alert("Error al conectar con el servidor.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-md space-y-4">
      {success && (
        <div className="p-3 bg-green-100 text-green-700 rounded">
          ¡Mensaje enviado con éxito!
        </div>
      )}
      <input
        id="nombre"
        placeholder="Nombre"
        value={formData.nombre}
        onChange={handleChange}
        className="w-full rounded border px-4 py-2"
        required
      />
      <input
        id="email"
        type="email"
        placeholder="Correo electrónico"
        value={formData.email}
        onChange={handleChange}
        className="w-full rounded border px-4 py-2"
        required
      />
      <textarea
        id="mensaje"
        placeholder="Mensaje"
        value={formData.mensaje}
        onChange={handleChange}
        className="w-full rounded border px-4 py-2"
        rows={4}
        required
      />
      <button
        type="submit"
        className="w-full bg-black text-white hover:bg-gray-800 px-4 py-2 rounded transition-colors disabled:opacity-50"
        disabled={isLoading}
      >
        {isLoading ? "Enviando..." : "Enviar mensaje"}
      </button>
    </form>
  );
}